import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { circles } from '../../data/circles';
import { SectionHeading } from '../ui/SectionHeading';
export function CirclesPreview() {
  const upcoming = circles.slice(0, 3);
  return <section className="bg-cream" aria-labelledby="circles-heading" data-id="element-113" data-mp="26bz0rhl5jurp">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-114" data-mp="26a4enzy59wm1">
        <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-end lg:gap-16" data-id="element-115" data-mp="1sjj2sv73ymxn">
          <SectionHeading eyebrow="Circles" title="Twelve women who already know what a rage morning is." intro="Small, facilitated, and scheduled — real rooms with real dates, not a forum badge. Cameras are optional and most people keep them off." data-id="element-116" data-mp="1xbiwi5wl4jls" />
          <Link to="/circles" className="group inline-flex items-center gap-2 self-start font-serif text-xl text-brick transition-colors duration-150 ease-brand hover:text-brick-deep lg:justify-self-end" data-id="element-117" data-mp="19lgb28n6ebw5">
            See every circle
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-brand group-hover:translate-x-1" aria-hidden="true" data-id="element-118" data-mp="3ud9wa13uj3tn" />
          </Link>
        </div>

        <ul className="mt-14 grid gap-px overflow-hidden rounded-brand border border-ink/15 bg-ink/15 lg:grid-cols-3" data-id="element-119" data-mp="86bekfqi0s05">
          {upcoming.map(circle => <li key={circle.slug} className="flex flex-col bg-cream-light p-8" data-id="element-120" data-mp="3gm4sqnxcxre1">
              <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-121" data-mp="3bo3dke31yc7u">{circle.kind}</p>
              <h3 className="mt-4 font-serif text-2xl leading-snug text-ink" data-id="element-122" data-mp="3qcg6t3ar9gyn">{circle.name}</h3>
              <p className="mt-4 text-[0.9375rem] leading-relaxed text-ink-soft" data-id="element-123" data-mp="3lk6clb2lxuqk">
                {circle.description}
              </p>
              <div className="rule mt-auto flex items-end justify-between gap-4 pt-5" data-id="element-124" data-mp="2xt0vytoueyf7">
                <div data-id="element-125" data-mp="2su6go1q33rzu">
                  <p className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-126" data-mp="3ikeib8698hd2">Next</p>
                  <p className="mt-1.5 text-[0.9375rem] text-ink" data-id="element-127" data-mp="3mm01tcdantw8">{circle.nextSession}</p>
                  <p className="mt-1 text-sm text-ink-soft" data-id="element-128" data-mp="3mjncuf94cj9o">{circle.host}</p>
                </div>
                {circle.seatsTotal > 0 && <p className="whitespace-nowrap text-sm text-brick" data-id="element-129" data-mp="5dp88d0jf9y">
                    {circle.seatsLeft} of {circle.seatsTotal} seats
                  </p>}
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}